import React from "react";
import { useConfig } from "../../../../../../context/config/configContext";

const HelpVideoDisplay = React.memo(({ selectedVideoLink }) => {
  const { config } = useConfig();
  const sasToken = config.REACT_APP_AZURE_SAS_TOKEN || "";
  // const sasToken = process.env.REACT_APP_AZURE_SAS_TOKEN;
  if (!selectedVideoLink) {
    return (
      <div className="p-6">
        <h3>Select a video to play</h3>
      </div>
    );
  }

  if (!sasToken) {
    return (
      <div className="p-6">
        <h3>Loading...</h3>
      </div>
    );
  }

  return (
    <div className="p-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      <video
        key={selectedVideoLink + sasToken}
        controls
        preload="metadata"
        className="w-full h-full object-cover bg-black"
      >
        <source
          src={selectedVideoLink + sasToken + "#t=0.1"}
          type="video/mp4"
        />
        Your browser does not support HTML video.
      </video>
    </div>
  );
});

export default HelpVideoDisplay;
